export default __webpack_public_path__ + "bg_virtu_blue.jpg";